import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  InputBase,
  Divider,
  Drawer,
  Stack,
  FormLabel,
  TextField,
  TableRow,
  TableCell,
  tableCellClasses,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  Modal,
  Pagination,
  Tooltip,
  IconButton,
  Chip,
} from "@mui/material";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import AddIcon from "@mui/icons-material/Add";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CloseIcon from "@mui/icons-material/Close";
import { RiDeleteBinLine, RiEditLine } from "react-icons/ri";
import { GrView } from "react-icons/gr";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import Controls from "../../Component/controls/Controls";
import { useForm } from "../../Utils/useForm";
import Notification from "../../Utils/Notification";
import {
  buyerStatusChange,
  deleteBuyer,
  getBuyerList,
} from "../../state/action/userAction";

const initialValues = { userName: "", companyName: "", email: "", mobile: "", status: "" };

const buyerStatusOptions = [
  { id: "1", title: "Active" },
  { id: "0", title: "Inactive" },
  { id: "3", title: "Delete" },
];

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#f8fafc",
    color: "#374151",
    fontSize: 13,
    fontWeight: 600,
    border: 0,
    padding: "14px 20px",
    whiteSpace: "nowrap",
    cursor: "pointer",
    userSelect: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#111827",
    border: 0,
    padding: "12px 20px",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  backgroundColor: "#fff",
  "&:nth-of-type(odd)": { backgroundColor: "#fafafa" },
  "&:hover": { backgroundColor: "#f1f5f9 !important", cursor: "pointer" },
  "&:last-child td": { border: 0 },
}));

const FilterTextField = styled(TextField)({
  "& .MuiOutlinedInput-input": { padding: "10px 14px", color: "#000" },
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(107, 114, 128, 0.4)",
    borderRadius: "8px",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#000" },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#4f46e5" },
  "& .MuiInputLabel-root": { color: "rgba(92,91,91,0.7)", fontSize: "14px" },
  "& label.Mui-focused": { color: "#4f46e5" },
});

const FilterLabel = styled(FormLabel)({
  display: "block",
  fontWeight: 600,
  fontSize: "13px",
  color: "#374151",
  marginTop: "16px",
  marginBottom: "6px",
});

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  bgcolor: "#fff",
  borderRadius: "12px",
  boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
  p: 4,
  outline: 0,
};

const SortIcon = ({ flag }) =>
  flag ? (
    <ArrowUpwardIcon sx={{ fontSize: "14px", ml: 0.5, color: "rgba(107,114,128,0.6)", verticalAlign: "middle" }} />
  ) : (
    <ArrowDownwardIcon sx={{ fontSize: "14px", ml: 0.5, color: "rgba(107,114,128,0.6)", verticalAlign: "middle" }} />
  );

export default function BuyerList() {
  const [buyerLists, setBuyerLists] = useState([]);
  const [pagePerSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [notify, setNotify] = useState({});
  const [openSwitchModel, setOpenSwitchModel] = useState(false);
  const [status, setStatus] = useState("");
  const [switchId, setSwitchId] = useState(null);
  const [fieldName, setFieldName] = useState("");
  const [checked, setChecked] = useState(true);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [search, setSearch] = useState("");
  const [flagName, setFlagName] = useState(false);
  const [flagPrice, setFlagPrice] = useState(false);
  const [flagEmail, setFlagEmail] = useState(false);
  const [flagMobile, setFlagMobile] = useState(false);
  const [filterData, setFilterData] = useState(true);
  const [filter, setFilter] = useState(false);

  const { state } = useLocation();
  const navigate = useNavigate();
  const { values, errors, setErrors, handleInputChange, resetForm } = useForm(initialValues);

  const fetchBuyerList = async (pg, name = "", flag) => {
    let string = Object.entries(values).map(([k, v]) => `&${k}=${v}`).join("");
    const query = `?page=${pg}&pagePerSize=${pagePerSize}&search=${search}${string}&sortBy=${name}&sortFlag=${flag}`;
    const res = await getBuyerList(query);
    if (res.status === true) {
      setBuyerLists(res.data);
      setTotalRecords(res.totalUser);
      setTotalPages(Math.ceil(res.totalUser / pagePerSize));
    } else {
      setBuyerLists([]);
      setTotalRecords(0);
      setTotalPages(0);
    }
  };

  useEffect(() => { fetchBuyerList(page, "", ""); }, [search, filterData]);

  useEffect(() => {
    if (state?.notify === true) setNotify({ isOpen: true, message: "Buyer Added Successfully.", type: "success" });
    if (state?.notify === "true1") setNotify({ isOpen: true, message: "Buyer Updated Successfully.", type: "success" });
  }, [state]);

  const handleChangePage = (e, val) => {
    setPage(val);
    if (fieldName === "userName") fetchBuyerList(val, fieldName, flagName);
    else if (fieldName === "email") fetchBuyerList(val, fieldName, flagEmail);
    else if (fieldName === "companyName") fetchBuyerList(val, fieldName, flagPrice);
    else if (fieldName === "mobile") fetchBuyerList(val, fieldName, flagMobile);
    else fetchBuyerList(val, "", "");
  };

  const dataSorting = (name) => {
    setFieldName(name);
    if (name === "userName") { setFlagName(!flagName); fetchBuyerList(page, name, !flagName); }
    if (name === "email") { setFlagEmail(!flagEmail); fetchBuyerList(page, name, !flagEmail); }
    if (name === "companyName") { setFlagPrice(!flagPrice); fetchBuyerList(page, name, !flagPrice); }
    if (name === "mobile") { setFlagMobile(!flagMobile); fetchBuyerList(page, name, !flagMobile); }
  };

  const handleChangeStatus = async () => {
    const res = await buyerStatusChange(switchId, { status: checked ? 1 : 0 });
    if (res?.status === true) {
      fetchBuyerList(page, fieldName, flagName);
      setOpenSwitchModel(false);
      setNotify({ isOpen: true, message: res.message || "Status changed successfully.", type: "success" });
    } else {
      setNotify({ isOpen: true, message: res.message || "Something went wrong.", type: "error" });
    }
  };

  const handleDelete = async (id) => {
    const res = await deleteBuyer(id);
    if (res?.status === true) {
      fetchBuyerList(page, fieldName, flagName);
      setOpenDeleteModel(false);
      setNotify({ isOpen: true, message: res.message || "Deleted successfully.", type: "success" });
    } else {
      setNotify({ isOpen: true, message: res.message || "Something went wrong.", type: "error" });
    }
  };

  return (
    <>
      {/* ── Page Header ── */}
      <Box sx={{ px: 3, pt: 4, pb: 2, backgroundColor: "rgb(241,245,249)" }}>
        <Typography variant="h2" sx={{ fontWeight: 700, color: "#111827", fontSize: "26px" }}>
          Buyers
        </Typography>
        <Typography sx={{ color: "rgb(107,114,128)", fontSize: "13px", mt: 0.5 }}>
          Manage all registered buyers
        </Typography>
      </Box>

      {/* ── Toolbar ── */}
      <Box sx={{ px: 3, pb: 2, backgroundColor: "rgb(241,245,249)" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 1.5,
          }}
        >
          {/* Search */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              border: "1px solid rgba(0,0,0,0.1)",
              borderRadius: "10px",
              px: 1.5,
              py: 0.5,
              minWidth: 260,
            }}
          >
            <SearchIcon sx={{ color: "rgba(107,114,128,0.6)", fontSize: "20px", mr: 1 }} />
            <InputBase
              placeholder="Search buyers..."
              sx={{ fontSize: "14px", color: "#000", flex: 1 }}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            />
          </Box>

          {/* Buttons */}
          <Box display="flex" gap={1.5}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate("/buyerAdd", { state: { buyer: "", companyId: "" } })}
              sx={{
                backgroundColor: "rgb(79,70,229)",
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "14px",
                px: 2.5,
                boxShadow: "none",
                "&:hover": { backgroundColor: "rgb(67,56,202)", boxShadow: "none" },
              }}
            >
              Add Buyer
            </Button>
            <Button
              variant="outlined"
              startIcon={<FilterAltIcon />}
              onClick={() => setFilter(true)}
              sx={{
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "14px",
                px: 2.5,
                color: "rgb(30,41,59)",
                borderColor: "rgba(30,41,59,0.3)",
                "&:hover": { backgroundColor: "rgb(30,41,59)", color: "#fff", borderColor: "rgb(30,41,59)" },
              }}
            >
              Filter
            </Button>
          </Box>
        </Box>
      </Box>

      {/* ── Table Card ── */}
      <Box sx={{ px: 3, pb: 4, backgroundColor: "rgb(241,245,249)" }}>
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "14px",
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          }}
        >
          <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell onClick={() => dataSorting("userName")}>
                    User Name <SortIcon flag={flagName} />
                  </StyledTableCell>
                  <StyledTableCell onClick={() => dataSorting("companyName")}>
                    Company Name <SortIcon flag={flagPrice} />
                  </StyledTableCell>
                  <StyledTableCell onClick={() => dataSorting("email")}>
                    Email <SortIcon flag={flagEmail} />
                  </StyledTableCell>
                  <StyledTableCell onClick={() => dataSorting("mobile")}>
                    Mobile <SortIcon flag={flagMobile} />
                  </StyledTableCell>
                  <StyledTableCell>Joined</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                  <StyledTableCell align="center">Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {buyerLists.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6, color: "#6b7280", fontSize: "15px", border: 0 }}>
                      No buyers found
                    </TableCell>
                  </TableRow>
                ) : (
                  buyerLists.map((row, index) => (
                    <StyledTableRow
                      key={index}
                      onClick={() => navigate("/buyerDetail", { state: { buyer: row?.userId, companyId: row?.companyId } })}
                    >
                      <StyledTableCell>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                          <Avatar
                            sx={{
                              width: 34,
                              height: 34,
                              fontSize: "13px",
                              fontWeight: 700,
                              backgroundColor: "rgba(79,70,229,0.12)",
                              color: "rgb(79,70,229)",
                            }}
                          >
                            {row.userName?.charAt(0)?.toUpperCase() || "B"}
                          </Avatar>
                          <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "#111827" }}>
                            {row.userName}
                          </Typography>
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell>{row.companyName || "—"}</StyledTableCell>
                      <StyledTableCell sx={{ color: "#6b7280" }}>{row.email}</StyledTableCell>
                      <StyledTableCell>{row.mobile}</StyledTableCell>
                      <StyledTableCell sx={{ color: "#6b7280", fontSize: "13px" }}>
                        {moment(row.createdAt).format("DD MMM YYYY")}
                        <Typography sx={{ fontSize: "11px", color: "#9ca3af", mt: 0.2 }}>
                          {moment(row.createdAt).fromNow()}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell onClick={(e) => e.stopPropagation()}>
                        <Chip
                          label={row.userStatus == "1" ? "Active" : "Inactive"}
                          size="small"
                          onClick={() => {
                            setOpenSwitchModel(true);
                            setStatus(row.userStatus == "1" ? "Inactive" : "Active");
                            setSwitchId(row.userId);
                            setChecked(row.userStatus != "1");
                          }}
                          sx={{
                            fontWeight: 600,
                            fontSize: "12px",
                            cursor: "pointer",
                            backgroundColor: row.userStatus == "1" ? "rgba(34,197,94,0.1)" : "rgba(239,68,68,0.1)",
                            color: row.userStatus == "1" ? "rgb(22,163,74)" : "rgb(220,38,38)",
                            border: `1px solid ${row.userStatus == "1" ? "rgba(34,197,94,0.3)" : "rgba(239,68,68,0.3)"}`,
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center" onClick={(e) => e.stopPropagation()}>
                        <Box display="flex" justifyContent="center" gap={0.5}>
                          <Tooltip title="View">
                            <IconButton
                              size="small"
                              onClick={() => navigate("/buyerDetail", { state: { buyer: row?.userId, companyId: row?.companyId } })}
                              sx={{ color: "#6b7280", "&:hover": { color: "rgb(79,70,229)", backgroundColor: "rgba(79,70,229,0.08)" } }}
                            >
                              <GrView size={15} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <IconButton
                              size="small"
                              onClick={() => navigate("/buyerEdit", { state: { buyer: row?.userId, companyId: row?.companyId } })}
                              sx={{ color: "#6b7280", "&:hover": { color: "rgb(34,197,94)", backgroundColor: "rgba(34,197,94,0.08)" } }}
                            >
                              <RiEditLine size={15} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton
                              size="small"
                              onClick={() => { setDeleteId(row.userId); setOpenDeleteModel(true); }}
                              sx={{ color: "#6b7280", "&:hover": { color: "rgb(239,68,68)", backgroundColor: "rgba(239,68,68,0.08)" } }}
                            >
                              <RiDeleteBinLine size={15} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          {buyerLists.length > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 2.5,
                py: 2,
                borderTop: "1px solid #f3f4f6",
              }}
            >
              <Typography sx={{ fontSize: "13px", color: "#6b7280" }}>
                Showing {Math.min((page - 1) * pagePerSize + 1, totalRecords)}–{Math.min(page * pagePerSize, totalRecords)} of {totalRecords} results
              </Typography>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChangePage}
                shape="rounded"
                size="small"
                sx={{
                  "& .MuiButtonBase-root": { color: "#374151", fontSize: "13px" },
                  "& .Mui-selected": { backgroundColor: "rgb(79,70,229) !important", color: "#fff !important" },
                }}
              />
            </Box>
          )}
        </Box>
      </Box>

      {/* ── Status Change Modal ── */}
      <Modal open={openSwitchModel} onClose={() => setOpenSwitchModel(false)}>
        <Box sx={modalStyle}>
          <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#111827", mb: 1 }}>
            Change Status
          </Typography>
          <Typography sx={{ fontSize: "14px", color: "#6b7280", mb: 3 }}>
            Are you sure you want to mark this buyer as <strong style={{ color: "#111827" }}>{status}</strong>?
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={1.5}>
            <Button
              onClick={() => setOpenSwitchModel(false)}
              sx={{ textTransform: "none", color: "#374151", borderColor: "#d1d5db", borderRadius: "8px" }}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleChangeStatus}
              variant="contained"
              sx={{ textTransform: "none", backgroundColor: "rgb(79,70,229)", borderRadius: "8px", boxShadow: "none", "&:hover": { backgroundColor: "rgb(67,56,202)", boxShadow: "none" } }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* ── Delete Modal ── */}
      <Modal open={openDeleteModel} onClose={() => setOpenDeleteModel(false)}>
        <Box sx={modalStyle}>
          <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#111827", mb: 1 }}>
            Delete Buyer
          </Typography>
          <Typography sx={{ fontSize: "14px", color: "#6b7280", mb: 3 }}>
            Are you sure you want to delete this buyer? This action cannot be undone.
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={1.5}>
            <Button
              onClick={() => setOpenDeleteModel(false)}
              sx={{ textTransform: "none", color: "#374151", borderColor: "#d1d5db", borderRadius: "8px" }}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleDelete(deleteId)}
              variant="contained"
              sx={{ textTransform: "none", backgroundColor: "rgb(239,68,68)", borderRadius: "8px", boxShadow: "none", "&:hover": { backgroundColor: "rgb(220,38,38)", boxShadow: "none" } }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* ── Filter Drawer ── */}
      <Drawer anchor="right" open={filter} onClose={() => { setFilter(false); resetForm(); setFilterData(!filterData); }}>
        <Box
          sx={{ width: 320, height: "100%", display: "flex", flexDirection: "column", backgroundColor: "#fff" }}
          component="form"
          onSubmit={(e) => { e.preventDefault(); setFilterData(!filterData); setFilter(false); }}
        >
          {/* Drawer Header */}
          <Box sx={{ px: 3, py: 2.5, borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontWeight: 700, fontSize: "18px", color: "#111827" }}>Filter</Typography>
            <IconButton size="small" onClick={() => setFilter(false)} sx={{ color: "#6b7280" }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Drawer Fields */}
          <Box sx={{ px: 3, py: 2, flex: 1, overflowY: "auto" }}>
            <FilterLabel>User Name</FilterLabel>
            <FilterTextField fullWidth name="userName" value={values.userName} onChange={handleInputChange} />

            <FilterLabel>Company Name</FilterLabel>
            <FilterTextField fullWidth name="companyName" value={values.companyName} onChange={handleInputChange} />

            <FilterLabel>Email</FilterLabel>
            <FilterTextField fullWidth name="email" value={values.email} onChange={handleInputChange} />

            <FilterLabel>Phone Number</FilterLabel>
            <FilterTextField fullWidth name="mobile" value={values.mobile} onChange={handleInputChange} />

            <FilterLabel>Status</FilterLabel>
            <Controls.SelectBox
              fullWidth
              name="status"
              value={values.status}
              onChange={handleInputChange}
              options={buyerStatusOptions}
            />
          </Box>

          {/* Drawer Footer */}
          <Box sx={{ px: 3, py: 2.5, borderTop: "1px solid #f3f4f6", display: "flex", gap: 1.5 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => { resetForm(); setFilterData(!filterData); setFilter(false); }}
              sx={{ textTransform: "none", borderRadius: "10px", color: "#374151", borderColor: "#d1d5db", fontWeight: 600 }}
            >
              Reset
            </Button>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{ textTransform: "none", borderRadius: "10px", backgroundColor: "rgb(79,70,229)", boxShadow: "none", fontWeight: 600, "&:hover": { backgroundColor: "rgb(67,56,202)", boxShadow: "none" } }}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Drawer>

      <Notification notify={notify} setNotify={setNotify} />
    </>
  );
}
